const translations = {
  rotationScreen: {
    message: 'Please rotate your device to portrait mode to view experience',
  },
  androidPlayer: {
    ariaClosePlayer: 'Close Player',
  },
  previewPane: {
    youLabel: 'You',
    statusLabel: 'Status',
    warrantyLabel: 'Warranty',
    registeredTo: 'Registered To',
    unregisteredLabel: 'Unregistered',
    ariaPreDiscountPrice: 'Pre-discount price',
    ariaPrice: 'Price',
  },
  registration: {
    productRegistered: 'Product Registered!',
    signedUp: "You're Signed Up!",
    warrantyActivated: 'Warranty Activated!',
    completeProfile: 'Complete Profile',
    registrationError: 'Registration error, please try again',
  },
  socialLogin: {
    withGoogleText: 'with Google',
    continueGoogleButton: 'Continue with Google',
    signinError: 'There was an error. Please try signing in again',
    popupBlockedMessage:
      'was blocked by your browser. Please disable popup blockers or choose the email option to continue.',
    cookiesDisabled:
      'Please enable cookies to continue or try registering with email.',
  },
  purchaseDetails: {
    receiptUploadSuccess: 'Receipt uploaded.',
    receiptUploadError: 'Error uploading receipt',
    noReceiptError: 'Please upload purchase receipt',
    firstnameInputPlaceholder: 'Enter first name...',
    firstnameFilledInputPlaceholder: 'First name',
    lastnameInputPlaceholder: 'Enter last name...',
    lastnameFilledInputPlaceholder: 'Last name',
    phoneNumberInputPlaceholder: 'Enter phone number...',
    emailInputPlaceholder: 'Enter email...',
    line1InputPlaceholder: 'Enter address line 1...',
    serialNumberInputPlaceholder: 'Enter serial number...',
    serialNumberFilledInputPlaceholder: 'Serial number',
    uploadReceiptButtonText: 'Upload Receipt',
    datepickerLabel: 'Purchase date...',
    datepickerFilledLabel: 'Purchase date',
    smsConsentRequired: 'Please check the consent box',
    invalidType: 'Invalid file type. Please upload an image or PDF',
    invalidDate: 'Invalid Date',
    retailChannelInputPlaceholder: 'Place of Purchase',
    retailChannelOtherInputPlaceholder: 'Enter your place of purchase',
    retailChannelRequired: 'Please select your place of purchase',
    quantitySelectorInputPlaceholder: 'Select Quantity',
    quantitySelectorInputOther: 'Other',
    failedToUpload: ' failed to upload',
    submitButtonText: 'Submit',
    receiptFailedError:
      'One or more of your receipts may not meet the requirements. Please consider re-uploading a clear, well-lit image of your receipt that includes the relevant line item(s).',
  },
  signIn: {
    pageTitle: 'Sign In to Brij',
    pageHeaderTitle: 'Sign In',
    withEmail: ' with Email',
    completeProfile: 'Complete Profile',
    useDifferentOption: 'Use a Different Option',
    continueWithEmail: 'Continue with Email',
    unitTagSignInLink: 'Request Sign In Link',
    checkYourEmail: 'Check your email',
    emailInputPlaceholder: 'Enter email...',
    emailInputFilledPlaceholder: 'Email',
    ariaEmail: 'Email',
    toastMessages: {
      invalidEmail: 'Please enter a valid email address',
      completeRecaptchaVerification: 'Please complete Recpatcha Verification',
      cantVerifyLoginDetails: 'Not able to verify the login details',
      emailConsentRequired: 'Please check the email consent box',
      privacyConsentRequired: 'Please check the privacy consent box',
    },
  },
  firebaseErrors: {
    'auth/invalid-email': 'Please provie a valid email',
    'auth/missing-email': 'Please provie an email',
    'auth/user-not-found': "User doesn't exist",
    'auth/wrong-password': 'Invalid email or password',
    'auth/internal-error': 'Server error occured',
    'auth/popup-closed-by-user':
      'Sign in canceled. Please complete the sign in process or choose email option to continue',
    'auth/cancelled-popup-request':
      'Sign in canceled. Please complete the sign in process or choose email option to continue',
    'auth/invalid-credential-or-provider-id': 'Invalid credentials',
    'auth/unauthorized-domain':
      'You are accessing the website from a non secure domain.',
    'auth/invalid-action-code': 'The code is invalid or expired',
    'auth/popup-blocked':
      'Popup blocked. Please enable popups or choose email option to continue.',
  },
  magicLink: {
    linkSentToastMessage: 'Welcome back! Check your email for a sign-in link.',
    magicLinkError: 'An error occurred',
    redirecting: 'Redirecting...',
  },
  ageGate: {
    title: 'Confirm your age',
    subtitle: 'Are you {{ageLimit}} or older?',
    confirmationButton: 'YES',
    disapprovalButton: 'NO',
    warningMessage: 'You must be {{ageLimit}}+ to view this site!',
  },
  cookieBanner: {
    bannerHeading: 'Accept the use of Cookies.',
    savePreferences: 'Save Preferences',
    preferencesSaved: 'Cookie preferences saved successfully',
    cookieSaveError: 'Error saving cookie preferences',
    essentialCookiesDescription:
      'Essential Cookies (For core site functionality)',
    functionalCookiesDescription:
      'Functional Cookies (Improve your experience)',
    analyticsCookiesDescription: 'Analytics Cookies (Help us improve our site)',
    marketingCookiesDescription: 'Marketing Cookies (Personalized ads)',
    socialCookiesDescription: 'Social Media Cookies (Enable sharing & embeds)',
    checkedStatus: 'Checked',
    uncheckedStatus: 'Unchecked',
    buttons: {
      cancel: 'Cancel',
      configure: 'Configure',
      acceptAll: 'Accept All',
      acceptSelected: 'Accept Selected Cookies',
    },
  },
  contentGate: {
    enterButton: 'ENTER',
    continueButton: 'CONTINUE',
    warningMessage: 'Sorry, you must be {{ageLimit}} or older',
    invalidYearInput: 'Please enter a valid year',
  },
  productDetails: {
    viewWarranty: 'View Warranty',
    youLabel: 'You',
    statusLabel: 'Status',
    warrantyLabel: 'Warranty',
    registeredTo: 'Registered To',
    unregisteredLabel: 'Unregistered',
    ariaPreDiscountPrice: 'Pre-discount price',
    ariaPrice: 'Price',
    ariaLogo: 'logo',
    ariaBrandLogo: 'Brand logo',
    isThisItemLost: 'Is this item lost?',
  },
  digitalHub: {
    searchBarPlaceholder: 'Tap to search...',
    dropdownNoResults: 'No results',
    serialNumberFound: 'Serial number found.',
    emptySerialNumberError: 'Please enter a serial number.',
    serialNumberNotFoundError: 'Serial Number not found. Please try again.',
    defaultSerialNumberButtonTitle: 'Open',
    serialNumberFilledInputPlaceholder: 'Serial Number',
    serialNumberEmptyInputPlaceholder: 'Enter your serial number...',
    enterText: 'Enter',
  },
  smsOptIn: {
    receiveMessageButton: 'Text Me & Get Started',
    sendMessageButton: 'Text Us & Get Started',
    trySendingAgain: 'Try again',
    sendMeText: 'Text me instead',
    sendUsText: 'Send a text instead',
    phoneNumberInputPlaceholder: 'Enter phone number...',
    consentRequiredError: 'Please check the consent box',
    checkYourPhone: 'Check your phone for a text message or email',
    errorSendingRequest: 'Error sending request. Please try again.',
    messageSentSuccessfully:
      'Please check your phone for a text message or email.',
    messageSentSuccessfullyEmail: 'Please check your email.',
    messageSentSuccessfullySms: 'Please check your phone for a text message.',
    messageSentSuccessfullyBoth: 'Please check your text or email.',
    invalidPhoneNumberError: 'Please enter a valid phone number',
    rebateAlreadyClaimedError:
      "You've already redeemed this offer the maximum number of times.",
    emailInputError: 'Please enter your email',
    invalidEmailError: 'Please enter a valid email',
    ariaRebateEmailInput: 'Rebate Email',
    rebateEmailInputPlaceholder: 'Enter your email...',
    rebateEmailInputFilledPlaceholder: 'Email',
    submitButtonText: 'Next',
    rebateIdError: 'Rebate ID not found',
    messageSentText:
      "A text message was sent to the number provided. Don't see it? ",
    messageSentTextEmail:
      "An email was sent to the address provided. Don't see it? ",
    messageSentTextBoth: "A text or email was sent. Don't see it? ",
    otpSentSuccess:
      'A verification code has been sent to your phone number. Please enter it below.',
    otpSendError: 'Failed to send verification code. Please try again.',
    otpInvalidLength: 'Please enter a valid 6-digit code',
    otpVerifyError: 'Invalid verification code. Please try again.',
    otpInputPlaceholder: 'Enter passcode',
    otpInputLabel: 'Passcode...',
    otpVerifyButton: 'Submit',
    sendCodeButton: 'Send Code',
    otpResendButton: "Didn't get a code? Try again.",
    otpResendCountdown: 'Resend in {{seconds}}s',
    otpChangePhone: 'Change Number',
    skipButtonText: 'Skip',
    otpPasscodeSentMessage:
      'A code has been sent to {{phoneNumber}}. Please enter it below to complete sign-up.',
    otpConfirmPhoneHeading: 'Last Step! Enter Verification Code',
    verifyPhoneNumberTitle: 'Verify Phone Number',
    verifyPhoneNumberDescription:
      'You will get a one time code to verify your identity',
    existingPhoneMessage:
      'You will get a one time code to verify your identity to the phone number ',
    existingProfileMessage: 'A profile already exists for this email using ',
    receiveCodeButton: 'Receive Code',
    defaultSmsDisclaimerText: `<p>By entering your phone number or by sending us a text message you agree to receive recurring automated promotional and personalized marketing text messages (e.g. special offers) from {{brand_name}} at the cell number used when signing up. Consent is not a condition of any purchase. Reply HELP for help and STOP to cancel. Msg frequency varies. Msg & data rates may apply. View <a href='https://brij.it/terms' target='_self'>Terms & Conditions</a> and <a href='https://brij.it/terms' target='_self'>Privacy Policy</a>.</p>`,
    defaultOtpText: `<p>By entering your phone number, you agree to receive a one-time SMS verification code. Msg & data rates may apply. View <a href="https://brij.it/terms" target="_self">Terms & Conditions</a> and <a href={{privacy_page_url}} target="_self">Privacy Policy</a>.<p>`,
    defaultEmailLegalText: `<p>By entering your email you agree to receive recurring automated promotional and personalized marketing mails (e.g. special offers) from {{brand_name}} at the email used when signing up. Consent is not a condition of any purchase. View <a href="https://brij.it/terms" target="_self">Terms & Privacy</a>.</p>`,
    rebateStatus: {
      heading: 'Rebate Status',
      helpText: 'You can track the progress of your rebate here.',
      rebateSignup: 'Rebate Signup',
      completed: 'Completed',
      approved: 'Approved',
      paid: 'Paid',
      rebateSubmission: 'Rebate Submission',
      awaitingReceipt: 'Awaiting receipt. Please upload.',
      awaitingReceiptWithoutUpload: 'Awaiting receipt via text message.',
      rebateApproval: 'Rebate Approval',
      rebatePayout: 'Rebate Payout',
      rebatePayoutHelpText:
        'Rebate payout is processing. Please allow up to 2 business days.',
      awaitingApproval: 'Under review. Please allow up to 2 business days.',
      rejected: 'Rejected',
      forTheFollowingReason: 'for the following reason:',
      pleaseResubmit: 'Please resubmit.',
    },
  },
  personalDetails: {
    smsConsentRequired: 'Please check the consent box',
    firstNameInputPlaceholder: 'First Name',
    lastNameInputPlaceholder: 'Last Name',
    phoneNumberInputPlaceholder: 'Phone Number',
    invalidFirstName: 'First name is required',
    invalidLastName: 'Last name is required',
    invalidPhoneNumber: 'Please enter a valid phone number',
    completeProfile: 'Complete Profile',
    continueButton: 'Continue',
    skip: `I'll do this later`,
  },
  sideMenu: {
    myCart: 'My Cart',
    myProfile: 'My Profile',
    myCollection: 'My Collection',
    visitWebsite: 'Visit Website',
    removeProduct: 'Remove Product',
    productRemoved: ' has been removed from your collection.',
    signOut: 'Sign Out',
    signIn: 'Sign In',
    signOutToastMessage: 'Logout Successful',
    translate: 'Translate',
    termsAndPrivacy: 'Terms & Privacy',
    sweepstakesRules: 'Sweepstakes Rules',
    markAsLost: 'Mark as Lost',
    returnToOwner: 'Return Lost Item',
    ariaSideMenuLabels: {
      ariaItems: 'items',
      ariaSignIn: 'Sign In',
      ariaProfile: 'My Profile',
      ariaCollection: 'My Collection',
      ariaVisitWebsite: 'Visit Website',
      ariaTermsAndPrivacy: 'Terms & Privacy',
      ariaSweepstakesRules: 'Sweepstakes Rules',
      ariaTranslate: 'Translate',
      ariaSignOut: 'Sign Out',
      ariaMarkAsLost: 'Mark as Lost',
      ariaReturnToOwner: 'Return Lost Item',
    },
  },
  profile: {
    pageTitle: 'Profile',
    pageHeaderTitle: 'Profile',
    firstNameInput: 'First Name',
    lastNameInput: 'Last Name',
    emailInput: 'Email',
    phoneNumberInput: 'Phone Number',
    saveChanges: 'Save Changes',
    updateToastMessage: 'Profile Updated',
  },
  collection: {
    pageTitle: 'My Collection',
    collectionPageTitle: 'My Collection',
    emptyCollectionMessage: 'No Products in your Collection',
    scanCodeButton: 'Scan Code',
    scanSuccessMessage: 'Product Scanned',
    scanErrorMessage: 'Scan Error',
    invalidScanMessage: 'Not a valid Brij code',
    expireStatus: 'Expires',
    purchaseStatus: 'Purchased',
    registerStatus: 'Registered',
    ariaProductThumbnail: 'Product Thumbnail',
  },
  termsAndPrivacy: {
    ariaBrandTerms: "Brand's Terms",
    ariaBrandPrivacy: "Brand's Privacy Policy",
    ariaTerms: 'Terms',
    ariaPrivacy: 'Privacy Policy',
    brijLegalName: 'Brij Inc.',
    pageHeaderTitle: 'Terms & Privacy',
    pageTitle: 'Terms & Privacy',
    subtitle: 'Terms & Conditions and Privacy Policy',
    questionsAboutData: 'Questions about your data?',
    contactUs: 'Contact us',
    legalNotice: `Brij Inc. acts as a service provider for {{brand_name}}, facilitating the collection and management of user data, including but not limited to email addresses and phone numbers. This partnership allows {{brand_name}} to utilize the data gathered through Brij Inc.'s platform for purposes specified in their respective privacy policies and terms of service. Brij Inc. is committed to handling this data responsibly and in compliance with all applicable data protection laws, ensuring that user privacy is respected and protected in the course of our collaboration with {{brand_name}}. `,
    legalNoticeMixed: `Please see the respective privacy policies and terms and conditions of both Brij Inc. and {{brand_name}} below for more detailed information.`,
    legalNoticeBrij: `Please see the privacy policiy and terms and conditions of Brij Inc. below for more detailed information.`,
    termsButton: 'Terms & Conditions',
    privacyButton: 'Privacy Policy',
    cookiesHeading: 'Accept the use of Cookies.',
  },
  lostAndFound: {
    pageTitle: 'Lost & Found',
    pageHeaderTitle: 'Return Lost Item',
    markAsLostTitle: 'Mark as Lost',
    saveButton: 'Save',
    itemLostCheckbox: 'This item is lost',
    itemStolenCheckbox: 'This item is stolen',
    ownerNameInputPlaceholder: 'Owner Dsiplay Name',
    successMessage: 'Message Sent!',
    successMessageDescription: 'You just made someone’s day!',
    errorSendingMessage: 'Error sending message, please try again later.',
    rewardHeading: 'Reward for Return',
    rewardVia: 'via',
    messageTextboxPlaceholder:
      'Type a message for the owner here so they know how to get their lost item back...',
    messageTextboxFilledPlaceholder: 'Message to owner...',
    locationTogglerTitle: 'Share your current GPS location',
    nameInputPlaceholder: 'Share your name... (optional)',
    nameInputFilledPlaceholder: 'Name...',
    emailInputPlaceholder: 'Share your email... (optional)',
    emailInputFilledPlaceholder: 'Email...',
    phoneInputPlaceholder: 'Share your phone number... (optional)',
    phoneInputFilledPlaceholder: 'Phone...',
    sendMessageButton: 'Send the Owner a Message',
    areYouOwnerText: 'Are you the owner? ',
    signInLinkText: 'Sign In',
  },
  gameRules: {
    pageTitle: 'Sweepstakes Rules',
    pageHeaderTitle: 'Sweepstakes Rules',
  },
  fourZeroFour: {
    pageTitle: '404 | Not Found',
    message: 'This experience does not exist',
    learnMoreButton: 'Learn about Brij',
    learnMoreLink: 'https://brij.it/',
  },
  header: {
    recommendationsHeading: 'Recommendations',
  },
  customSelectInput: {
    noOptions: 'NO OPTIONS',
    ariaNoResults: 'No Results',
    ariaCustomValue: 'Custom Value',
  },
  socialicons: {
    ariaPhone: 'Phone',
    ariaEmail: 'Email',
    ariaTiktok: 'Tiktok',
    ariaTwitter: 'X',
    ariaInstagram: 'Instagram',
    ariaThreads: 'Threads',
    ariaFacebook: 'Facebook',
    ariaLinkedIn: 'LinkedIn',
    ariaYoutube: 'Youtube',
    ariaWhatsApp: 'WhatsApp',
    ariaDiscord: 'Discord',
  },
  toggleComponent: {
    ariaToggleOn: 'Toggle On',
    ariaToggleOff: 'Toggle Off',
  },
  phoneInput: {
    ariaChangeCountryCode: 'Change country code',
  },
  datePickerComponent: {
    ariaChangeDate: 'Change date',
  },
  searchableDropDown: {
    noOptions: 'No Options',
    ariaToggleDropdown: 'Toggle dropdown',
  },
  drawers: {
    bottomDrawer: {
      ariaCloseDrawer: 'Close Drawer',
      multipleRegistrationText: 'Need to register another product? Tap here',
      callToActionButton: 'Call to Action',
      moreButton: 'More',
    },
    autoDeploy: {
      ariaCloseDrawer: 'Close Drawer',
      titles: {
        purchaseScreen: 'Add Purchase Details',
        completeProfileScreen: 'Complete Profile',
      },
    },
    authDrawer: {
      termsAndConditions: {
        part1: 'By registering you agree to email communications from ',
        part2: ' and accept ',
        brijBrand: " Brij's ",
        linkText: 'Terms & Conditions',
        part3: ' For help or questions email ',
        helpEmail: 'support@brij.it',
        unitTagDisclaimer:
          'If you are the owner of this product and are having difficulty signing in, please contact ',
      },
      unitTag: {
        heading: 'Welcome Back',
        description:
          'To view this content, please tap the button below to have a sign in link sent to the registered email address.',
      },
      viewDetails: 'View Details',
      fullTermsLink: 'See full terms',
      emailConsentRequired: 'Please check the email consent box',
      privacyConsentRequired: 'Please check the privacy consent box',
      and: 'and',
      sweepstakesRules: 'Sweepstakes Rules',
      successMessage: {
        productRegistered: 'Product Registered!',
        signedUp: "You're Signed Up",
        warrantyActivated: 'Warranty Activated!',
      },
    },
    registrationDrawer: {
      purchaseDetailsHeading: 'Add Purchase Details',
      successDrawer: {
        title: 'Product Registered!',
        description: 'Check your email for details',
      },
    },
    ab899Drawer: {
      testResultsLookup: 'Test Results Lookup',
      ariaToggleDetails: 'Toggle details for lot number',
      ariaToggleDetailsFor: 'Toggle details for',
      ariaCaution: 'Caution:',
      enterNameOrUpcOrLotNumber:
        "Enter your product's name, UPC or lot number to see testing results.",
      enterUpcOrLotNumber:
        "Enter your product's UPC or lot number to see testing results.",
      enterNameOrLotNumber:
        "Enter your product's name or lot number to see testing results.",
      enterNameOrUpcNumber:
        "Enter your product's name or UPC to see testing results.",
      enterUpcNumber: "Enter your product's UPC to see testing results.",
      enterName: "Enter your product's name to see testing results.",
      enterLotNumber: "Enter your product's lot number to see testing results.",
      lotNumberEmptyInputPlaceholder: 'Enter lot number',
      lotNumberInputPlaceholder: 'Lot number',
      optionalPlaceholderText: '(optional)',
      upcAndProductEmptyPlaceholder: 'Enter Product Name or UPC',
      upcNumberEmptyPlaceholder: 'Enter UPC number',
      upcProductEmptyPlaceholder: 'Enter Product Name',
      upcAndProductInputPlaceholder: 'Product Name or UPC',
      upcNumberInputPlaceholder: 'UPC number',
      upcProductInputPlaceholder: 'Product Name',
      submitLotNumberButton: 'Search Results',
      lotNumberHeading: 'Lot No',
      testDateHeading: 'Test Date',
      expirationDateHeading: 'Exp. Date',
      viewFullReportButton: 'View all test results',
      startOverButton: 'Start Over',
      loadMoreButton: 'See {{count}} More',
      heavyMetalsHeading: 'Heavy Metals',
      pesticidesAndGlyphosateHeading: 'Pesticides & Glyphosate',
      plasticizersHeading: 'Plasticizers (BPA, BPS)',
      standardHeading: 'Standard',
      noProductsFoundMessage: 'No products found',
      typeToSearchMessage: 'Type to search',
      disclaimer:
        'Testing was performed in compliance with California AB 899 standards. For the latest FDA guidance and information on the health effects of toxic elements on children, please ',
      disclaimerLink: 'visit this link',
      showMore: 'Show more',
      showLess: 'Show less',
      sb646Disclaimer:
        "Prenatal multivitamins containing certain minerals critical to support an expectant person's health and proper development of their fetus may contain trace levels of heavy metals that occur in the environment naturally or from human activities. The levels of heavy metals in prenatal multivitamin ingredients may vary depending on whether and at what levels the prenatal multivitamin contains these ingredients, as well as the location from which the ingredients are sourced. Certain foods containing minerals critical to support an expectant person's health and proper development of their fetus may also contain heavy metals.",
      errors: {
        emptyLotOrUpcNumber:
          'Please enter a UPC number or a lot number to proceed',
        noRecordFound:
          'Unable to find test data. Please ensure that the UPC or lot number is entered correctly.',
      },
    },
    sweepstakesDrawer: {
      entryDateHeading: 'Entry Date',
      entryIdHeading: 'Entry ID',
      sweepstakesEntryStatus: {
        entryApproved: 'Entry Approved',
        entryPending: 'Entry Pending',
        entryDenied: 'Entry Denied',
        entryExpired: 'Sweepstakes Expired',
      },
      sweepstakesEntryStatusMessage: {
        entryActiveMessage:
          "You have successfully entered this sweepstakes. We'll reach out if you're selected.",
        entryPendingReviewMessage:
          'Your sweepstakes entry is under review. Check back soon to view your status.',
        entryDeniedMessage:
          'Your entry was denied. Please ensure that your entry meets all requirements for this sweepstakes.',
        sweepstakesExpiredMessage:
          'This sweepstakes has ended. Thank you for participating.',
      },
    },
    warrantyDrawer: {
      warrantyHeading: 'Warranty Active',
      warrantyHeadingWithMulberry: 'Extended Warranty by Mulberry',
      expiredWarrantyHeading: 'Warranty Expired',
      pendingWarrantyHeading: 'Warranty Pending Review',
      deniedWarrantyHeading: 'Warranty Denied',
      mulberryDefaultHeader: 'Stay Covered for Longer',
      mulberryDefaultDescription:
        'For a limited time, upgrade to extend your protection at the lowest rates, guaranteed.',
      mulberryDefaultButtonCta: 'Extend My Warranty Coverage',
      mulberryExpirationNotice:
        'Warranty extensions are managed by Mulberry Technology Inc. and are available for purchase until ',
      mulberryPolicyTerms: 'View Policy Terms',
      mulberryLinkError:
        'We could not open your warranty extension. Please try again.',
      mulberryMissingInfoError:
        'We still need your name and address to set up your extension.',
      mulberryHelpText: {
        part1: 'Extended warranty plans are managed by',
        part2:
          'Contact help@getmulberry.com with questions regarding your extended warranty.',
      },
      lifetimeLabel: 'Lifetime',
      pendingInfoText:
        'Your warranty registration is currently under review. Check back later to view its status.',
      deniedInfoText:
        'Your warranty registration was denied. Please submit a valid dated receipt below and ensure the purchase date matches the date on the receipt.',
      issueDate: 'Start Date',
      expirationDate: 'Expiration Date',
      termLength: 'Term Length',
      fullTermsLink: 'See full terms',
      viewDetails: 'View Details',
      detailsModal: {
        activateWarrantyHeading: 'Activate Warranty',
        updateWarrantyHeading: 'Update Details',
        description:
          'To activate your warranty please enter the purchase date and upload a dated receipt.',
        updateDescription:
          'To update your purchase details, please enter the new purchase date and upload a dated receipt.',
        activateButton: 'Activate',
        updateButton: 'Update',
        cancelButton: 'Cancel',
      },
      successDrawer: {
        title: 'Warranty Activated!',
        description: 'Check your email for details',
      },
    },
    referralDrawer: {
      copyLinkButton: 'Copy link',
      copyLinkToastMessage: 'Copied to clipboard',
      shareLinkButton: 'Share link',
      shareText: 'Have a look at this product from Brij',
      helpText: 'Have your friend scan this code',
    },
    smsDrawer: {
      signUpButton: 'Sign up for VIP texts',
      subscriptionDisclaimer:
        'By signing up via text, you agree to receive recurring automated personalized and promotional marketing text messages from Canopy at the cell number used when signing up. Consent is not a condition of any purchase. Reply HELP for help and STOP to cancel. Msg frequency varies. Msg & data rates may apply. Must be a resident of the US and 18 years or older. View Terms and Privacy.',
    },
    shopDrawer: {
      successDrawer: {
        title: 'Order Placed!',
        description: 'Check your email for an order confirmation',
      },
      productGrid: {
        ariaPreDiscountPrice: 'Pre-discount price',
        ariaPrice: 'Price',
      },
      productDetails: {
        showMore: 'More',
        showLess: 'Less',
      },
      savingBanner: {
        title: "You're saving",
      },
      cartButton: {
        callToAction: 'Add to Cart',
        invalidCombo: 'Out of Stock',
        invalidQuantity: 'Select Quantity',
      },
      checkoutHint: {
        chooseOptions: 'Please choose options',
        comboUnavailable: 'Combination not available',
      },
      recommendations: {
        title: 'Recommendations',
        seeMore: 'See More',
      },
      ariaShopLabels: {
        ariaReturn: 'Return',
        ariaImageFor: 'Image for',
        ariaPreDiscountPrice: 'Pre-discount price',
        ariaPrice: 'Price',
      },
      cartResetNotification: 'A new cart has been created for ',
      cartClearedNotification: 'Cart cleared due to brand change',
    },
    cartDrawer: {
      ariaCartLabels: {
        ariaCloseDrawer: 'Close Drawer',
        ariaImageFor: 'Image for',
        ariaPreDiscountPrice: 'Pre-discount price',
        ariaPrice: 'Price',
        ariaDecreaseQuantity: 'Decrease quantity',
        ariaIncreaseQuantity: 'Increase quantity',
      },
      checkoutButton: {
        callToAction: 'Checkout',
      },
      drawerTitle: 'My Cart',
      emptyCartText: 'There are currently no items in your cart',
    },
    discountDrawer: {
      discountCodeHeading: 'Discount Code:',
      copiedToClipboard: 'Discount Code copied to clipboard',
    },
    formDrawer: {
      submit: 'Submit',
      next: 'Next',
      start: 'Start',
      ariaBack: 'Back',
      regFormFetchError:
        'Registration form fetch unsuccessful. Please refresh and try again.',
      formCompletetionMessage: 'Your responses were submitted successfully.',
      formSubmissionError: 'Form submission failed. Please resubmit',
      submissionSuccessful: 'Submission Successful',
      submitAnotherResponse: 'Submit Another Response',
      validationErrors: {
        specialCharactersError: 'Special characters are not allowed',
        minimumCharactersError:
          'Value must be at least {{minimumValue}} characters',
        maximumCharactersError:
          'Value must be at most {{maximumValue}} characters',
        numericValueError: 'Value must be numeric',
        minimumDigitsError: 'Value must be at least {{minimumDigits}} digits',
        maximumDigitsError: 'Value must be at most {{maximumDigits}} digits',
        minimumValueError: 'Value must be at least {{minimumValue}}',
        maximumValueError: 'Value must be at most {{maximumValue}}',
        dateRangeError: 'Date must be between {{startDate}} and {{endDate}}',
        ageRangeError:
          'You must be between {{minimumAge}} and {{maximumAge}} years old to proceed',
        minimumAgeError:
          'You must be at least {{minimumAge}} years old to proceed',
        maximumAgeError: 'You must be over {{maximumAge}} years old to proceed',
      },
      fileUpload: {
        fileName: 'File Name...',
        uploadFileButton: 'Upload Files',
        syncToS3Error: 'File Failed to sync to s3 please upload again.',
        fileSizeError: 'File size exceeds 20MB. Please resubmit.',
        fileLimitError: '5 file limit exceeded. Please resubmit.',
        fileExtensionError: `File extenstion not supported. valid files are .pdf, .jpeg,
        .jpg, heic and .png`,
      },
      textArea: {
        placeholder: 'Type your answer here...',
        placeholderFilled: 'Your answer...',
      },
      dropDown: {
        selectText: 'Click to select',
      },
      searchableDropDown: {
        selectText: 'Type to search...',
      },
      datePicker: {
        placeholder: 'Please select a date',
        errorMessage: 'Invalid Date',
      },
      addressFields: {
        countryPlaceholder: 'Choose Country',
        addressLineOnePlaceholder: 'Address line 1',
        addressLineTwoPlaceholder: 'Address line 2',
        cityPlaceholder: 'City',
        stateDropdownPlaceholder: 'Choose state',
        stateFieldPlaceholder: 'State',
        zipcodePlaceholder: 'Zip',
        optionalPlaceholderText: '(optional)',
      },
      firstNamePlaceholder: 'First Name',
      lastNamePlaceholder: 'Last Name',
    },
  },
};

export default translations;
